module.exports = __webpack_public_path__ + "img/image.56d57052.svg";